//FIX ORDER
import slimscroll from "jquery-slimscroll";
import SmoothScroll from 'smooth-scroll';
import IMC_FILTER from "./libs/_filter/imcfilter";

jQuery(document).ready(function () {
 //   require("./libs/_init/app_main_trigger.js");

    //window.popover  = Popper;
    window.myapp_config = require("./libs/_config/app.config.js");
    window.myapp_get_color = require("./libs/_get/app.get.colors.js");
    window.initApp = require("./libs/_init/app.init.js");

    //require("./libs/_modules/app.imcfilter.js");
    require("./libs/_modules/app.domReady.js");
    require("./libs/_modules/app.orientationchange.js");
    require("./libs/_modules/app.resize.trigger.js");
    require("./libs/_modules/app.scroll.trigger.js");
    require("./libs/_modules/app.window.load.js");
    require("./libs/_modules/app.navigation.js");


    window.IMC_FILTER = new IMC_FILTER();

});




